<template>
  <div
    class="tw-bg-white tw-pt-[17px] tw-pb-[16px] !tw-px-[20px] xl:!tw-px-[60px] tw-relative tw-w-full tw-flex tw-justify-between tw-items-center active-path-header_wrapper"
  >
    <div class="tw-flex tw-flex-wrap tw-gap-[15px] tw-m-0 tw-w-full">
      <!-- Active Path -->
      <div class="tw-flex-grow tw-p-0">
        <div class="tw-flex tw-items-center tw-h-full">
          <active-path-header :path="activeHierarchy" :navigate="navigate" />
        </div>
      </div>

      <!-- Button Action -->
      <div class="tw-flex-grow-0 tw-w-full sm:tw-w-auto tw-p-0">
        <div
          class="group-button-action tw-flex tw-flex-nowrap tw-justify-start sm:tw-justify-end tw-gap-[20px] tw-items-center tw-p-0"
        >
          <Button1
            v-if="buttonTitle"
            :id="idButton1"
            :data-cy="dataCy1"
            :class="`tw-min-w-[136px] button ${buttonClass} ${
              isOutline ? 'button-outline' : ''
            }`"
            :title="buttonTitle"
            :disabled="isButtonEnable"
            :is-outline="isOutline"
            :is-loading="isBtnLoading"
            :css-button="'tw-whitespace-nowrap'"
            @click="() => $emit('click-button')"
          />
          <Button1
            v-if="button2Title"
            :id="idButton2"
            :data-cy="dataCy2"
            :class="`button ${isOutline2 ? 'button-outline' : ''}`"
            :title="button2Title"
            :disabled="isButton2Enable"
            :is-loading="isBtn2Loading"
            :css-button="'tw-whitespace-nowrap'"
            @click="() => $emit('click-button2')"
          />
          <Button1
            v-if="button3Title"
            :id="idButton3"
            :class="`button ${isOutline2 ? 'button-outline' : ''}`"
            :title="button3Title"
            :disabled="isButton3Enable"
            :is-loading="isBtn3Loading"
            :css-button="'tw-whitespace-nowrap'"
            @click="() => $emit('click-button3')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import ActivePathHeader from "./activePathHeader.vue";
import Button1 from "./button1.vue";
import ButtonLoading from "./buttonLoading.vue";

@Component({
  components: {
    ActivePathHeader: ActivePathHeader,
    Button1: Button1,
    ButtonLoading: ButtonLoading,
  },
  emits: ["click-button", "click-button2", "click-button3"],
})
export default class ActivePathWrapper extends Vue {
  @Prop({ required: true }) readonly activeHierarchy: Array<string> = [];

  @Prop({ required: false, default: false }) readonly isButtonEnable: boolean =
    false;

  @Prop({ required: false, default: false }) readonly isButton2Enable: boolean =
    false;

  @Prop({ required: false, default: false }) readonly isButton3Enable: boolean =
    false;

  @Prop({ required: false, default: "" }) readonly buttonTitle: string = "";
  @Prop({ required: false, default: "" }) readonly button2Title: string = "";
  @Prop({ required: false, default: "" }) readonly button3Title: string = "";

  @Prop({ required: false, default: "" }) readonly buttonClass: string = "";

  @Prop({ required: false, default: "" }) readonly idButton1: string = "";
  @Prop({ required: false, default: "" }) readonly idButton2: string = "";
  @Prop({ required: false, default: "" }) readonly dataCy1: string = "";
  @Prop({ required: false, default: "" }) readonly dataCy2: string = "";
  @Prop({ required: false, default: "" }) readonly idButton3: string = "";
  @Prop({ required: false, default: false }) readonly isOutline: boolean =
    false;
  @Prop({ required: false, default: false }) readonly isOutline2: boolean =
    false;
  @Prop({ required: false, default: false }) readonly buttonClass1: string = "";
  @Prop({ required: false, default: false }) readonly buttonClass2: string = "";
  @Prop({ required: false, default: false }) readonly buttonClass3: string = "";

  @Prop({ required: false }) readonly navigate: Array<string> = [];

  @Prop({ required: false, default: false }) readonly isBtnLoading: boolean =
    false;

  @Prop({ required: false, default: false }) readonly isBtn2Loading: boolean =
    false;

  @Prop({ required: false, default: false }) readonly isBtn3Loading: boolean =
    false;
  @Prop({ required: false, default: "" }) readonly isCallApi: boolean = false;
}
</script>

<style scoped>
.active-path-header_wrapper {
  border-bottom: 1px solid #eff0f1;
  background-color: #fff;
  border-bottom: 1px solid var(--UI-rule, #eff0f1);
}

.button {
  border-radius: 100px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  color: var(--UI-white, #fff);
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 10px;
  text-align: center;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  height: 36px !important;
}
.button-outline {
  border: 2px solid #387dff;
  box-shadow: none;
  background: #ffffff;
  color: #387dff !important;

  &.disabled {
    background: var(--ui-light-grey-50, #dbdbdb);
    color: #b7b7b7 !important;
    border: none;
    cursor: not-allowed;
  }
  &:hover {
    color: #ffffff !important;
  }
}
@media (max-width: 1280px) {
  .active-path-header_wrapper {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 525px) {
  .group-button-action {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding-right: 0px;
  }
}
</style>
